module.exports = __webpack_public_path__ + "static/media/1.fa4f32a1.jpg";